export const assColorToRgba = (color: string): string => {
  const match = color.match(
    /^&H([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/
  );
  if (!match) {
    throw new Error(`Invalid color format: ${color}`);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, aa, bb, gg, rr] = match;
  const toDec = (hex: string) => parseInt(hex, 16);

  const alpha = (255 - toDec(aa)) / 255;

  return `rgba(${toDec(rr)}, ${toDec(gg)}, ${toDec(bb)}, ${alpha})`;
};
